import { fetchQgisResource } from "helpers/qgisClient";

const imageLoadState = new WeakMap();

const releaseObjectUrl = (state) => {
  if (!state.objectUrl) return;
  URL.revokeObjectURL(state.objectUrl);
  state.objectUrl = null;
};

const clearImageLoadState = (imageElement, state) => {
  imageElement.removeEventListener("load", state.release);
  imageElement.removeEventListener("error", state.release);
  releaseObjectUrl(state);
  if (imageLoadState.get(imageElement) === state) {
    imageLoadState.delete(imageElement);
  }
};

const cancelPreviousImageLoad = (imageElement) => {
  const previousState = imageLoadState.get(imageElement);
  if (!previousState) return;

  previousState.controller.abort();
  clearImageLoadState(imageElement, previousState);
};

export const loadAuthenticatedQgisImage = async (image, src) => {
  const imageElement = image.getImage();
  cancelPreviousImageLoad(imageElement);

  const state = {
    controller: new AbortController(),
    objectUrl: null,
    release: null,
  };
  state.release = () => clearImageLoadState(imageElement, state);
  imageLoadState.set(imageElement, state);

  try {
    const response = await fetchQgisResource(src, {
      signal: state.controller.signal,
    });
    const blob = await response.blob();

    if (imageLoadState.get(imageElement) !== state) return;

    state.objectUrl = URL.createObjectURL(blob);
    imageElement.addEventListener("load", state.release);
    imageElement.addEventListener("error", state.release);
    imageElement.src = state.objectUrl;
  } catch (error) {
    if (imageLoadState.get(imageElement) !== state) return;
    clearImageLoadState(imageElement, state);
    throw error;
  }
};

export const createAuthenticatedQgisImageLoadFunction = ({ onError } = {}) =>
  (image, src) => {
    const imageElement = image.getImage();

    loadAuthenticatedQgisImage(image, src).catch((error) => {
      onError?.(error);
      imageElement.dispatchEvent(new Event("error"));
    });
  };
